"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewComponent = void 0;
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const function_client_1 = require("@/utils/function-client");
const userSchema_1 = __importDefault(require("./userSchema"));
const schemaComponents_1 = require("@/schemaComponents");
const components_1 = require("utils/components");
const PreviewComponent = ({ control }) => {
    const { email } = (0, react_hook_form_1.useWatch)({ control });
    const [userRecord, userRecordLoading] = (0, function_client_1.useGetAdminUserRecord)(email ? { email } : undefined);
    return email && userRecordLoading ? (react_1.default.createElement(components_1.Loading, null)) : (react_1.default.createElement(schemaComponents_1.DynamicField, { data: userRecord, schema: userSchema_1.default }));
};
exports.PreviewComponent = PreviewComponent;
